import { ChartField } from '../chart.model'
import { NUM_MATCHED_ITEMS_VALUE_FIELD } from '../constants'
import { TargetComparison } from '../enums'
import { CASHFLOW_JOB_FIELDS } from './job-lookup.model'

export const CASHFLOW_ALL_FIELDS: ChartField[] = [
  {
    dataField: 'jobDescription',
    displayName: 'Job Description',
    dataType: 'string',
  },
  {
    dataField: 'taskDescription',
    displayName: 'Task Description',
    dataType: 'string',
  },
  {
    dataField: 'isPracticalCompletionTask',
    displayName: 'Is Practical Completion Task',
    dataType: 'boolean',
  },
  {
    dataField: 'isForecastStart',
    displayName: 'Is Forecast Start',
    dataType: 'boolean',
  },
  {
    dataField: 'forecastPaymentDate',
    displayName: 'Forecast Payment Date',
    dataType: 'date',
    isDefault: true,
  },
  {
    dataField: 'forecastCompletionDate',
    displayName: 'Forecast Completion Date',
    dataType: 'date',
  },
  {
    dataField: 'forecastStartDate',
    displayName: 'Forecast Start Date',
    dataType: 'date',
  },
  {
    dataField: 'invoiceDate',
    displayName: 'Invoice Date',
    dataType: 'date',
  },
  {
    dataField: 'incomeReceivable',
    displayName: 'Income Receivable',
    dataType: 'number',
    numberPrefix: '$',
  },
  {
    dataField: 'incomeReceivableExGst',
    displayName: 'Income Receivable Ex GST',
    dataType: 'number',
    numberPrefix: '$',
  },
  {
    dataField: 'costSubcontractor',
    displayName: 'Cost - Subcontractor',
    dataType: 'number',
    numberPrefix: '$',
    defaultTargetComparison: TargetComparison.AtMost,
  },
  {
    dataField: 'costSupplier',
    displayName: 'Cost - Supplier',
    dataType: 'number',
    numberPrefix: '$',
    defaultTargetComparison: TargetComparison.AtMost,
  },
  {
    dataField: 'totalFlow',
    displayName: 'Total Flow',
    dataType: 'number',
    numberPrefix: '$',
  },
  {
    dataField: 'totalFlowExGst',
    displayName: 'Total Flow Ex GST',
    dataType: 'number',
    numberPrefix: '$',
  },
  ...CASHFLOW_JOB_FIELDS,
]

export const CASHFLOW_FILTER_FIELDS: ChartField[] = CASHFLOW_ALL_FIELDS

export const CASHFLOW_DATE_FILTER_FIELDS: ChartField[] = CASHFLOW_ALL_FIELDS.filter(
  (field) => field.dataType === 'date'
)

export const CASHFLOW_ARGUMENT_FIELDS: ChartField[] = CASHFLOW_ALL_FIELDS.filter(
  (field) => field.dataType !== 'number'
)

export const CASHFLOW_VALUE_FIELDS: ChartField[] = [NUM_MATCHED_ITEMS_VALUE_FIELD].concat(
  CASHFLOW_ALL_FIELDS.filter((field) => field.dataType === 'number')
)

export const CASHFLOW_SERIES_GROUP_FIELDS: ChartField[] = CASHFLOW_ALL_FIELDS.filter(
  (field) => field.dataType === 'string' || field.dataType === 'boolean'
)
